import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c5e2f104 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _4b53b776 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _720f2199 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _49b4dd36 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _0afa63f6 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _1e1c88d1 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _8980bc62 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _2c2262ea = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _4019d0f3 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _5ec519d8 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1f9800e8 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _50befab0 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _1d94852e = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _e226bef6 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1cffd986 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _6a34d6e8 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _074a03cf = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _d6090776 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _bb673114 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _b8e09254 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _4e1dbc22 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _5d1359e6 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _02d153fe = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _3ab99bcc = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _aac0bcdc = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _9881d65a = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _1f2658d5 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _65e534cd = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _114f0c2a = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _090d965d = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _bbb2e6d8 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _e103320e = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _ed6ae1a0 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _754a83e8 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _bd0f96ac = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _e353760c = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _3dc59615 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _e9f3496e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _48329956 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _16565bfb = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _4b800b7b = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _75e3cdc7 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _f63ad3d0 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _0d6e4fd6 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _23b98dd8 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _27377938 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _348cc1e4 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _02dbaf28 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _3a61fc30 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _6fec0878 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _6c8f5f4b = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _1c4d2b93 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _7d77526c = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _2d891f44 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3def88de = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _2bb1fa14 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _e8dbdd26 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _2b46a2d2 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _d06fb45a = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _902c4a84 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _e1c8f6bc = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _5ee40675 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _18dac4d0 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _3c0f3f60 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _3c7c19bd = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _4e175d34 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _540a937e = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _2891fd3e = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _32068dad = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _ec8517ca = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _68fdc560 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _151ee0c4 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _31398172 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _67721340 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _4c5dc3d0 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _7b3f0f10 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _c5e2f104,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _4b53b776,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _720f2199,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _49b4dd36,
    name: "calendar"
  }, {
    path: "/customer",
    component: _0afa63f6,
    name: "customer"
  }, {
    path: "/details",
    component: _1e1c88d1,
    name: "details"
  }, {
    path: "/goals",
    component: _8980bc62,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _2c2262ea,
    name: "maisoku"
  }, {
    path: "/media",
    component: _4019d0f3,
    name: "media"
  }, {
    path: "/privacy",
    component: _5ec519d8,
    name: "privacy"
  }, {
    path: "/project",
    component: _1f9800e8,
    name: "project"
  }, {
    path: "/response",
    component: _50befab0,
    name: "response"
  }, {
    path: "/sale",
    component: _1d94852e,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _e226bef6,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1cffd986,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _6a34d6e8,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _074a03cf,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _d6090776,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _bb673114,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _b8e09254,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _4e1dbc22,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _5d1359e6,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _02d153fe,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _3ab99bcc,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _aac0bcdc,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _9881d65a,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _1f2658d5,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _65e534cd,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _114f0c2a,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _090d965d,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _bbb2e6d8,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _e103320e,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _ed6ae1a0,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _754a83e8,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _bd0f96ac,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _e353760c,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _3dc59615,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _e9f3496e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _48329956,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _16565bfb,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _4b800b7b,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _75e3cdc7,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _f63ad3d0,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _0d6e4fd6,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _23b98dd8,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _27377938,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _348cc1e4,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _02dbaf28,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _3a61fc30,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _6fec0878,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _6c8f5f4b,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _1c4d2b93,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _7d77526c,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _2d891f44,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _3def88de,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _2bb1fa14,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _e8dbdd26,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _2b46a2d2,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _d06fb45a,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _902c4a84,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _e1c8f6bc,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _5ee40675,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _18dac4d0,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _3c0f3f60,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _3c7c19bd,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _4e175d34,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _540a937e,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _2891fd3e,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _32068dad,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _ec8517ca,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _68fdc560,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _151ee0c4,
    name: "property-property",
    children: [{
      path: "contact",
      component: _31398172,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _67721340,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _4c5dc3d0,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _7b3f0f10,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
